<template>
    <div class="account">
        <div class="details">
            <div class="field">
                <div class="control">
                    <div class="columns is-centered">
                        <div class="column has-text-centered is-12">
                            <h1 class="has-text-weight-bold is-size-4">Account Settings</h1>
                        </div>
                    </div>
                </div>
            </div>
            <div class="field">
                <div class="control">
                    <div class="columns is-centered">
                        <!-- <div class="column has-text-centered is-3 profile-image">
                            <div class='formfield'>
                                <div class='account-user-image'>
                                    <a :href="profileImageUrl" target="_blank"><img :src="profileImageUrl" /></a>
                                    <div style="margin-top: 24px;">
                                    <file-uploader :vuexStore="fileUploadStore" :vuexSelectAction="fileSelectAction" :vuexUploadAction="fileUploadAction" :setDescription="setDescription" :buttonName="buttonName"></file-uploader>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        <div class="column has-text-centered is-8">
                            <div class="field">
                                <div class="control">
                                    <div class="columns">
                                        <div class="column is-6">
                                            <label>Email (this is your account login)</label>
                                            <div class='formfield'><input type="text" :value="user.username" class="input" readonly="readonly" /></div>
                                        </div>
                                        <div class="column is-6">
                                            <label>Password</label>
                                            <div class='formfield'>
                                                <input type="password" :value="password" autocomplete="off" class="input" v-bind:class="{ 'is-danger': passwordErr }" @blur="checkValue('password', $event.target.value)" @focus="clearErrorMsgs('password')" @change="update('password', $event.target.value)"/>
                                            </div>
                                            <p v-if="passwordErr" class="help is-danger is-danger-password">Password is required</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="field">
                                <div class="control">
                                    <div class="columns">
                                        <div class="column is-6">
                                            <label>First Name</label>
                                            <div class='formfield'><input type="text" :value="formData.first_name" class="input" v-bind:class="{ 'is-danger': firstNameErr }" @blur="checkValue('first_name', $event.target.value)" @focus="clearErrorMsgs('first_name')" @change="update('first_name', $event.target.value)"/></div>
                                            <p v-if="firstNameErr" class="help is-danger is-danger-password">First name is required</p>
                                        </div>
                                        <div class="column is-6">
                                            <label>Last Name</label>
                                            <div class='formfield'><input type="text" :value="formData.last_name" class="input" v-bind:class="{ 'is-danger': lastNameErr }" @blur="checkValue('last_name', $event.target.value)" @focus="clearErrorMsgs('last_name')" @change="update('last_name', $event.target.value)"/></div>
                                            <p v-if="lastNameErr" class="help is-danger is-danger-password">Last name is required</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="field">
                                <div class="control">
                                    <div class="columns">
                                        <div class="column is-6">
                                            <label>Phone Number</label>
                                            <div class='formfield'><input type="text":value="formData.cell_phone" class="input" v-bind:class="{ 'is-danger': cellPhoneErr }" @blur="checkValue('cell_phone', $event.target.value)" @focus="clearErrorMsgs('cell_phone')" @change="update('cell_phone', $event.target.value)"/></div>
                                            <p v-if="cellPhoneErr" class="help is-danger is-danger-password">Phone number is required</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="field">
                                <div class="control">
                                    <div class="columns is-centered is-vcentered">
                                        <div class="column is-12">
                                            <button @click="saveProfile" class='button is-link' v-bind:class="{ 'is-loading': isLoading }">Save Changes</button>
                                            <button @click="closeModal" class='button tertiary-button'>Cancel</button>
                                        </div>
                                        <!-- <div class="column is-6">
                                            <transition name="fade">
                                                <span v-if="showSuccess" class="has-text-centered has-text-success">{{successMessage}}</span>
                                            </transition>
                                                <span v-if="savingError && false" class="has-text-centered has-text-danger">{{errorMessage}}</span>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    data () {
        return {
            fileUploadStore: 'user',
            fileSelectAction: 'canUploadFile',
            fileUploadAction: 'uploadUserProfile',
            buttonName: 'Upload Image',
            setDescription: false,
            firstNameErr: false,
            lastNameErr: false,
            emailErr: false,
            passwordErr: false,
            userNameErr: false,
            cellPhoneErr: false
        }
    },

    computed: {
        ...mapGetters('user', {
            profileImageUrl: 'getProfileImageUrl',
            user: 'getFormData'
        }),

        ...mapGetters('vendors', {
            formData: 'getFormData'
        }),

        ...mapState('profile', {
            canSave: state => state.canSave,
            isLoading: state => state.isLoading,
            password: state => state.password,
            successMessage: state => state.successMessage,
            showSuccess: state => state.showSuccess,
            savingError: state => state.savingError,
            errorMessage: state => state.errorMessage,
        }),
    },

    methods:{
        /**
         * Save profile changes
         * @return {[type]} [description]
         */
        saveProfile(){
            if(this.firstNameErr == false && this.lastNameErr == false && this.passwordErr == false && this.userNameErr == false && this.cellPhoneErr == false){
                VueStore.dispatch('profile/setBoolean', {key: 'isLoading', bool: true})
                VueStore.dispatch('profile/update');
            } else {
                 VueStore.dispatch('profile/setBoolean', {key: 'savingError', bool: true})
            }
        },

        /**
         * Valid required fields
         */
        checkValue(field, val){
            if(val.trim() === ''){
                switch(field){
                    case 'first_name':
                        this.firstNameErr = true;
                        break;
                    case 'last_name':
                        this.lastNameErr = true;
                        break;
                    case 'email':
                        this.emailErr = true;
                        break;
                    case 'password':
                        this.passwordErr = true;
                        //update password because it's currently holding ** as placeholder
                        VueStore.dispatch('profile/setBoolean', {key: 'password', bool: ''});
                        break;
                    case 'username':
                        this.userNameErr = true;
                        break;
                    case 'cell_phone':
                        this.cellPhoneErr = true;
                        break;
                }
            }
        },

        /**
         * Clears error messages on focus
         */
        clearErrorMsgs(field){
            switch(field){
                case 'first_name':
                    this.firstNameErr = false;
                    break;
                case 'last_name':
                    this.lastNameErr = false;
                    break;
                case 'email':
                    this.emailErr = false;
                    break;
                case 'password':
                    this.passwordErr = false;
                    break;
                case 'username':
                    this.userNameErr = false;
                    break;
                case 'cell_phone':
                    this.cellPhoneErr = false;
                    break;
            }
        },

        /**
         * Update vuex object
         */
        update(key, value){
            if(key == 'username' || key == 'password'){
                VueStore.dispatch('user/updateSelectedData', {key: key, value: value});
                if(key == 'password'){
                    //reset placeholder with *
                    VueStore.dispatch('profile/setBoolean', {key: 'password', bool: '************'});
                }
            } else {
                VueStore.dispatch('vendors/updateDataForServer', {key: key, value: value});
            }
        },

        /**
         * Enable save button on keyup
         */
        enableSave(){
            VueStore.dispatch('profile/setBoolean', {key: 'canSave', bool: true})

        },

        /**
         * disable save button on keyup
         */
        disableSave(){
            //console.log("disable");
            VueStore.dispatch('profile/setBoolean', {key: 'canSave', bool: false})

        },

        /*
         * Close profile modal
         */
        closeModal: function(){
            VueStore.dispatch('profile/validateModal');
        }
    },

    created(){
    },

    mounted(){
    },
}
</script>

<style>
.account-user-image img{
    width: 150px;
    height: 150px;
    margin-top: 3px;
    border-radius: 50%;
}
</style>
